module.exports = __webpack_public_path__ + "img/norway-endocrine-nutritional-metabolic-diseases-female.ec67232c.png";